// import { ResponsiveCalendar } from '@nivo/calendar';
import CalendarHeatmap from 'react-calendar-heatmap';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { Header, Icon, Modal, Popup, Segment } from 'semantic-ui-react';

import { CustomContainer } from '../common';
import { DEFAULT_DAYS_AGO } from '../../constants';
import { formatDatetime } from '../Utils';
import { shiftDate } from './utils';

// const CHART_HEIGHT = 500;
// const CHART_HEIGHT_MOBILE = 375;

const MESSAGES = {
  SHOW_RECENT_ACTIVITIES: `
    使用者在過去一定時間內的活動情形
    可以試著點方塊區塊檢視當日的發文或回文喔
  `,
};

const STYLES = {
  QUESTION_ICON: {
    float: 'right',
    cursor: 'pointer',
    color: '#7f8c8d',
  },
};

const mapValueToClass = (entry) => {
  if (!entry) {
    return 'color-empty';
  }

  const count = parseInt(entry.count, 10);

  if (!count) {
    return 'color-empty';
  }

  if (count > 0 && count <= 3) {
    return 'color-github-1';
  }

  if (count > 3 && count <= 9) {
    return 'color-github-2';
  }

  if (count > 9 && count <= 15) {
    return 'color-github-3';
  }

  if (count > 15 && count <= 20) {
    return 'color-github-4';
  }

  if (count > 20 && count <= 25) {
    return 'color-github-5';
  }

  if (count > 25 && count <= 30) {
    return 'color-github-6';
  }

  if (count > 30 && count <= 40) {
    return 'color-github-7';
  }

  return 'color-github-8';
};

const today = new Date();

// const renderUsingNivoCalendar = () => (
//   <ResponsiveCalendar
//     data={data.map(({ date, count }) => ({
//       day: formatDatetime(date),
//       value: computeValue(count),
//     }))}
//     from={formatDatetime(data[0].date)}
//     to={formatDatetime(data[data.length - 1].date)}
//     height={isMobile ? CHART_HEIGHT_MOBILE : CHART_HEIGHT}
//     direction={isMobile ? 'vertical' : 'horizontal'}
//     emptyColor="#eeeeee"
//     colors={[ '#61cdbb', '#97e3d5', '#e8c1a0', '#f47560' ]}
//     tooltip={({ day, value }) => {
//       return value > 0 ? (
//         <Label pointing='below' color='black'>
//           {day} {'->'} 文章數 + 評論數: {value}
//         </Label>
//       ) : (
//         <Label pointing='below' color='black'>
//           沒有任何活動喔
//         </Label>
//       );
//     }}
//     margin={{
//       top: 20,
//       right: 10,
//       bottom: 20,
//       left: 20,
//     }}
//     yearSpacing={40}
//     monthSpacing={0}
//     monthBorderWidth={0}
//     monthBorderColor="#ffffff"
//     dayBorderWidth={2}
//     dayBorderColor="#ffffff"
//     onClick={(entry) => (entry.value > 0) && this.fetchDailyActivites(entry.day)}
//     minValue={'auto'}
//     maxValue={'auto'}
//   />
// );

export default class Activities extends Component {
  state = {
    showDailyActivitiesDetails: false,
    dailyActivitiesAt: null,
  }

  fetchDailyActivites = (at) => {
    this.setState({
      showDailyActivitiesDetails: true,
      dailyActivitiesAt: at,
    });

    this.props.fetchDailyActivites(
      this.props.userId,
      at,
    );
  }

  render() {
    const {
      computeValue,
      dailyActivitiesDetails,
      data,
      getTooltipDataAttrs,
      isFetching,
      isMobile,
      renderActivitiesDetails,
    } = this.props;

    const {
      showDailyActivitiesDetails,
      dailyActivitiesAt,
    } = this.state;

    const hasRecentActivities = Array.isArray(data) && (data.length > 0);

    return (
      <div ref={this.setWrapperRef}>
        <CustomContainer>
          <Modal
            open={showDailyActivitiesDetails}
            centered={false}
            dimmer="blurring"
            onClose={() => this.setState({
              showDailyActivitiesDetails: false,
            })}
            closeIcon
          >
            <Modal.Header>
              {dailyActivitiesAt}
              {' '}
              的歷史紀錄
            </Modal.Header>
            <Modal.Content scrolling>
              {renderActivitiesDetails(
                dailyActivitiesDetails.data,
                dailyActivitiesDetails.isFetching,
                isMobile,
              )}
            </Modal.Content>
          </Modal>
          <Header as={isMobile ? 'h3' : 'h2'} attached="top">
            近期活動
            {' '}
            (
            {DEFAULT_DAYS_AGO / 30}
            個月之內)
            <div
              style={STYLES.QUESTION_ICON}
            >
              <Popup
                trigger={<Icon name="question" size="small" />}
                content={MESSAGES.SHOW_RECENT_ACTIVITIES}
                position="bottom right"
              />
            </div>
          </Header>
          <Segment
            attached
            loading={isFetching}
          >
            {
              hasRecentActivities ? (
                <div>
                  <CalendarHeatmap
                    startDate={shiftDate(today, -DEFAULT_DAYS_AGO)}
                    endDate={today}
                    values={data.map(({ date, count }) => ({
                      date: formatDatetime(date),
                      count: computeValue(count),
                      ...count,
                    }))}
                    classForValue={mapValueToClass}
                    tooltipDataAttrs={(value) => getTooltipDataAttrs(value)}
                    showMonthLabels
                    showWeekdayLabels={!isMobile}
                    onClick={(entry) => entry && this.fetchDailyActivites(entry.date)}
                  />
                  <ReactTooltip />
                </div>
              ) : (
                <p>沒有任何資料喔...</p>
              )
            }
          </Segment>
        </CustomContainer>
      </div>
    );
  }
}
